'use client'
import GameFrame from '@/src/components/Player/GameFrame'
import DemoGameFrame from '@/src/components/Player/GameFrame/DemoGameFrame'
import useAuthGuard from '@/src/hooks/useAuthGuard'
import { FamilyType } from '@/src/services/types/games'

type GameClientProps = {
  gameFamily: FamilyType
  children?: React.ReactNode
  providername?: string | undefined
}

function GameClient({ children, gameFamily, providername }: GameClientProps) {
  const { isLoggedIn } = useAuthGuard()

  return isLoggedIn ? (
    <GameFrame gameFamily={gameFamily} />
  ) : (
    <DemoGameFrame gameFamily={gameFamily} providername={providername}>
      {children}
    </DemoGameFrame>
  )
}

export default GameClient
